import React, { useEffect, useState } from "react";
import { itemsPerPage } from "../../utils/constants";
import DataTable from "../../common/dataTable";
import TablePagination from "../../common/tablePagination";
import { Box, Radio } from "@mui/material";
import Searchbar from "../../common/searchbar";
import MauvelousPrimaryButton from "../../common/button/mauvelousPrimaryButton";
import { useDispatch, useSelector } from "react-redux";
import masterFormsActions from "../../redux/masterForms/actions";
import CreateMasterModal from "./modals/createMasterModal";
import { useForm } from "react-hook-form";
import EditMasterModal from "./modals/editMasterModal";
import commonActions from "../../redux/common/actions";
import { PiPlusBold } from "react-icons/pi";
import masterActions from "../../redux/master/actions";

const tableKeys = [
  {
    name: "SI.NO",
    accessor: "id",
    // accessor: 'genderid',
    sortOption: false,
  },
  {
    name: "Grievance category",
    accessor: "category",
    sortOption: false,
  },
  {
    name: "Grievance code",
    accessor: "grievancecode",
    sortOption: false,
  },
  {
    name: "Grievance",
    accessor: "grievance",
    sortOption: false,
  },
  {
    name: "Is Answerable",
    accessor: "isanswerablevalue",
    sortOption: false,
  },
  {
    name: "Is Raise Ticket",
    accessor: "israiseticketvalue",
    sortOption: false,
  },
  {
    name: "Enable",
    accessor: "enable",
    sortOption: false,
  },
  {
    name: "Disable",
    accessor: "disable",
    sortOption: false,
  },
];

export default function GrievancetypeMaster() {
  const dispatch = useDispatch();

  const { grievancetypeList } = useSelector(
    (state) => state.masterFormsReducer
  );

  const { backofficeTokenDetails } = useSelector((state) => state.authReducer);

  const [itemOffset, setItemOffset] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    watch,
    control,
    getValues,
    trigger,
  } = useForm({
    mode: "onChange",
    reValidateMode: "onChange",
    defaultValues: {},
  });

  useEffect(() => {
    dispatch({ type: masterFormsActions.GET_GRIEVANCECATEGORY });
    dispatch({ type: masterFormsActions.GET_GRIEVANCETYPE });
    //eslint-disable-next-line
  }, []);

  const handleActive = (active, type, grievanceid) => {
    if (type !== active) {
      let data = {
        userid: backofficeTokenDetails?.id,
        id: grievanceid,
        idname: "grievanceid",
        status: type,
        action: masterFormsActions.GET_GRIEVANCETYPE,
      };

      dispatch({
        type: masterActions.SET_MASTERS_STATUS,
        payload: data,
      });
    }
  };

  const endOffset = itemOffset + itemsPerPage;
  const currentItems = grievancetypeList?.filtered
    ?.map((obj) => {
      return {
        ...obj,
        enable: (
          <Radio
            checked={obj.status === "1"}
            onClick={() => handleActive(obj.status, "1", obj.grievanceid)}
          />
        ),
        disable: (
          <Radio
            checked={obj.status === "0"}
            onClick={() => handleActive(obj.status, "0", obj.grievanceid)}
          />
        ),
      };
    })
    ?.slice(itemOffset, endOffset);

  const pageCount = Math.ceil(
    grievancetypeList?.filtered?.length / itemsPerPage
  );

  const handlePageChange = (event, value) => {
    const newOffset = (value - 1) * itemsPerPage;
    setItemOffset(newOffset);
    setCurrentPage(value);
  };

  const handleCreate = (data) => {
    data["categoryid"] = data.grievancecategory;
    // data['grievancecode'] = data.grievancecode;
    data["grievance"] = data.name;
    data["isanswerable"] = data.isanswerable?.toString();
    data["israiseticket"] = data.israiseticket?.toString();
    data["answer"] = data.answer || "";
    data["status"] = "1";
    data["userid"] = backofficeTokenDetails?.id;
    dispatch({
      type: masterFormsActions.CREATE_GRIEVANCETYPE,
      payload: { data: data, resetForm: resetForm },
    });
  };

  const resetForm = () => {
    reset({
      grievancecategory: "",
      grievancecode: "",
      grievance: "",
      isanswerable: "",
      israiseticket: "",
      answer: "",
    });
  };

  const handleSearch = (e) => {
    let filtered = [];
    setCurrentPage(1);
    setItemOffset(0);
    if (e.target.value) {
      //eslint-disable-next-line
      filtered = grievancetypeList?.all?.filter((val) => {
        if (
          val?.grievance
            ?.toLowerCase()
            .includes(e.target.value?.toLowerCase()) ||
          val?.grievancecode
            ?.toLowerCase()
            .includes(e.target.value?.toLowerCase()) ||
          val?.category?.toLowerCase().includes(e.target.value?.toLowerCase())
        ) {
          return val;
        }
      });
    } else {
      filtered = [...grievancetypeList?.all];
    }
    dispatch({
      type: masterFormsActions.SET_GRIEVANCETYPE,
      payload: { ...grievancetypeList, filtered: filtered },
    });
  };

  const handleMasteredit = (page, value) => {
    dispatch({
      type: commonActions.SET_SHOW_MODAL,
      payload: { show: true, type: page, method: "U", data: null },
    });
    reset({
      ...value,
      name: value?.grievance,
      grievancecategory: value?.categoryid,
    });
  };

  const handleUpdate = (data) => {
    data["categoryid"] = data.grievancecategory;
    // data['grievancecode'] = data.grievancecode;
    data["grievance"] = data.name;
    data["isanswerable"] = data.isanswerable?.toString();
    data["israiseticket"] = data.israiseticket?.toString();
    data["answer"] = data.answer || "";
    data["status"] = "1";
    data["userid"] = backofficeTokenDetails?.id;
    dispatch({
      type: masterFormsActions.UPDATE_GRIEVANCETYPE,
      payload: { id: data?.grievanceid, data: data, resetForm: resetForm },
    });
  };

  const handleshowModal = () => {
    dispatch({
      type: commonActions.SET_SHOW_MODAL,
      payload: { show: true, type: "grievancetype", method: "C", data: null },
    });
  };

  return (
    <>
      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
          marginTop: "24px",
          marginBottom: "14px",
        }}
      >
        {/* <Box></Box> */}
        <Searchbar height={48} handleSearch={handleSearch} />
        <MauvelousPrimaryButton
          title={"Add"}
          icon={<PiPlusBold />}
          handleClick={handleshowModal}
        />
      </Box>
      <Box sx={{ height: "calc(100vh - 280px)" }}>
        <DataTable
          keys={tableKeys}
          values={currentItems}
          page={"grievancetype"}
          handleMasteredit={handleMasteredit}
        />
      </Box>
      <Box
        sx={{
          position: "fixed",
          bottom: 0,
          right: "24px",
          padding: "15px 0",
          width: "100%",
          py: 1,
        }}
      >
        <TablePagination
          pageCount={pageCount}
          handlePageChange={handlePageChange}
          currentPage={currentPage}
        />
      </Box>
      <CreateMasterModal
        register={register}
        handleSubmit={handleSubmit}
        getValues={getValues}
        trigger={trigger}
        errors={errors}
        handleCreate={handleCreate}
        resetForm={resetForm}
        watch={watch}
        control={control}
      />
      <EditMasterModal
        register={register}
        handleSubmit={handleSubmit}
        getValues={getValues}
        trigger={trigger}
        errors={errors}
        handleUpdate={handleUpdate}
        resetForm={resetForm}
        watch={watch}
        control={control}
      />
    </>
  );
}
